import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Icon from 'icon-component';

class DialogBack extends Component {
    constructor(props) {
        super(props);

        this._backClick = this._backClick.bind(this);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    _backClick(evt) {
        this.props.onClick();
    }

    render() {
        return (
            <button className="Dialog-back" onClick={this._backClick}>
                <Icon name="chevron-left" />
            </button>
        );
    }
}

DialogBack.propTypes = {
    onClick: PropTypes.func
};

export default DialogBack;



// WEBPACK FOOTER //
// ./frontend/src/js/components/dialog/DialogBack.jsx